import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Process from "../components/Process";
import Customer from "../components/Customer";

import AnimatedBack from "../images/AnimatedBack.gif";
import SD1 from "../images/Sd1.png";
import SD2 from "../images/Sd2.png";
import SD3 from "../images/Sd3.png";
import SD4 from "../images/Sd4.png";
import SD5 from "../images/Sd5.png";
import SD6 from "../images/Sd6.png";
import SD7 from "../images/SD7.png";
import SD8 from "../images/SD8.png";
import SD9 from "../images/SD9.png";
import SD10 from "../images/SD10.png";
import SD11 from "../images/SD11.png";
import SD12 from "../images/SD12.png";

import PHP1 from "../images/PHP1.png";
import PHP2 from "../images/PHP2.png";
import PHP3 from "../images/PHP3.png";
import PHP4 from "../images/PHP4.webp";
import PHP5 from "../images/PHP5.jpeg";

import OS1 from "../images/OS1.jpg";
import OS2 from "../images/OS2.png";
import OS3 from "../images/OS3.jpeg";
import OS4 from "../images/OS4.jpeg";
import OS5 from "../images/OS5.jpeg";
import OS6 from "../images/OS6.webp";
import OS7 from "../images/OS7.jpg";

import HTML1 from "../images/HTML1.webp";
import HTML2 from "../images/HTML2.jpeg";
import HTML3 from "../images/HTML3.jpg";
import HTML4 from "../images/HTML4.jpeg";

import JS1 from "../images/JS1.png";
import JS2 from "../images/JS2.jpeg";
import JS3 from "../images/JS3.jpg";
import JS4 from "../images/JS4.png";
import JS5 from "../images/JS5.jpeg";

import NET1 from "../images/NET1.webp";
import NET2 from "../images/NET2.png";

import "../css/SoftwareD.css";

function SoftwareD() {
  const [dropdowns, setDropdowns] = useState({
    PHP: false,
    OS: false,
    HTML: false,
    JS: false,
    ASP: false,
  });

  const toggleDropdown = (service) => {
    setDropdowns((prev) => ({
      PHP: false,
      OS: false,
      HTML: false,
      JS: false,
      ASP: false,
      [service]: !prev[service],
    }));
  };

  return (
    <>
      <Header />
      <div className="Softwared">
        {/* Banner Section */}
        <div className="Softwared-above">
          <img src={AnimatedBack} alt="banner" className="Softwared-img" />
          <div className="Softwared-above-info">
            <p className="Softwared-p" style={{ marginTop: "40px", marginBottom: "-10px" }}>Best Software</p>
            <p className="Softwared-p">Development Company</p>
            <p className="Softwared-p1">
              Unlock your company's full potential with our tailored software
              development services, designed to meet your unique business needs
              and drive growth.
            </p>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="Sofwared-main1">
          <p className="Softwared-main1-title">Why Choose Us?</p>
          <p className="Softwared-main1-desc">
            Purohit Technosoft is a renowned IT firm specializing in crafting
            highly customized and efficient software solutions tailored to meet
            unique business needs.
          </p>
          <div className="Sofwared-main1-boxes">
            {[SD1, SD2, SD3, SD4, SD5, SD6].map((img, index) => (
              <div className="Sofwared-main1-box" key={index}>
                <img src={img} alt={`service-${index + 1}`} />
                <p>
                  {[
                    "Customer delight",
                    "Cost-effective",
                    "Innovative Solutions",
                    "Market-ready",
                    "Assistance Provided",
                    "Customer delight",
                  ][index]}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Software Development Services Section */}
        <div className="Appd-main2">
          <p className="Appd-main2-title">Software Development Services</p>
          <p className="Appd-main2-desc">
            Discover the Broadest Array of Software Development Services
          </p>
          <div className="Appd-main2-boxes">
            {[SD7, SD8, SD9, SD10, SD11, SD12].map((img, index) => (
              <div className="Appd-main2-box" key={index}>
                <img src={img} alt={`service-${index + 7}`} />
                <p className="Appd-main2-box-title">
                  {[
                    "RPA",
                    "Internet of things",
                    "Alexa",
                    "Computer Vision",
                    "Mobile Application",
                    "Blockchain",
                  ][index]}
                </p>
                <p className="Appd-main2-box-desc">
                  {
                    [
                      "We empower organizations to reduce manual labor by swiftly developing software robots...",
                      "By harnessing advanced IoT technologies and edge computing, we build connected apps...",
                      "We design and develop tailored Alexa skills for businesses...",
                      "For startups and established companies, we offer skilled AI developers...",
                      "We quickly develop scalable, high-performance mobile applications...",
                      "Having worked on more than 30 blockchain projects, we have empowered businesses...",
                    ][index]
                  }
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Process Section */}
        <Process />

        {/* Web Development Dropdown Section */}
        <div className="Webd-main3">
          <p className="Webd-main3-title">Services we offer for Web Development</p>
          <p className="Webd-main3-desc">
            Excellence and innovation Using the Most Recent Technology
          </p>
          {[
            {
              key: "PHP",
              icon: "fa-brands fa-php",
              title: "PHP",
              description:
                "PHP is a widely-used, open-source, server-side programming language...",
              images: [PHP1, PHP2, PHP3, PHP4, PHP5],
              labels: ["CodeIgniter", "Laravel", "Cake PHP", "YII", "Zend"],
            },
            {
              key: "OS",
              icon: "fa-brands fa-osi",
              title: "Open Source",
              description:
                "We utilize open-source technologies, tools, and frameworks...",
              images: [OS1, OS2, OS3, OS4, OS5, OS6, OS7],
              labels: ["Drupal", "Joomla", "Magento", "Open Cart", "Presta Shop", "Shopify", "WordPress"],
            },
            {
              key: "HTML",
              icon: "fa-brands fa-html5",
              title: "HTML5 & CSS3",
              description:
                "Develop websites that deliver an intuitive user experience...",
              images: [HTML1, HTML2, HTML3, HTML4],
              labels: ["Bootstrap", "CSS3", "Grid System", "HTML5"],
            },
            {
              key: "JS",
              icon: "fa-brands fa-square-js",
              title: "JavaScript",
              description:
                "We excel in JavaScript, creating highly responsive interfaces...",
              images: [JS1, JS2, JS3, JS4, JS5],
              labels: ["Angular JS", "JQuery", "Node JS", "React JS", "Vue JS"],
            },
            {
              key: "ASP",
              icon: "fa-brands fa-battle-net",
              title: "ASP .Net",
              description:
                "Using a powerful server-side application framework, we develop dynamic and scalable web pages...",
              images: [NET1, NET2],
              labels: [".Net MVC", ".Net Core"],
            },
          ].map((service) => (
            <div
              className="Webd-main3-option"
              key={service.key}
              onClick={() => toggleDropdown(service.key)}
            >
              <i className={`${service.icon} fa-xl`}></i>
              <p>{service.title}</p>
              {dropdowns[service.key] && (
                <div className="dropdown-info">
                  <p>{service.description}</p>
                  <div className="dropdown-info-images">
                    {service.images.map((img, i) => (
                      <div className="dropdown-images-box" key={i}>
                        <img
                          src={img}
                          alt={service.labels[i]}
                          className="dropdown-info-image"
                        />
                        <p>{service.labels[i]}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Customer Section */}
        <Customer />

      </div>
      <Footer />
    </>
  );
}

export default SoftwareD;
